export function logError(error: Error): void {
  const now = new Date();
  const logMessage = `[${now.toISOString()}] ${error.name}: ${error.message}\n${error.stack}\n\n`;

  console.error(logMessage);
}